import { render, staticRenderFns } from "./PromotionalUpsellDetails.vue?vue&type=template&id=34b7d918"
import script from "./PromotionalUpsellDetails.vue?vue&type=script&lang=js"
export * from "./PromotionalUpsellDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports